// app/javascript/components/ReportsView.jsx
import React, { useEffect } from "react";
import PropTypes from "prop-types";

// Utility for your link path
// In a real app, you might pass in the full URL from Rails or use a helper.
function userReportPath({ group, license, track, user }) {
  // Mimics `u_group_license_mapped_sequence_progress_individual_path(@group, @license, track, user)`
  return `/groups/${group.id}/licenses/${license.id}/tracks/${track.id}/users/${user.id}/mapped_sequence_progress`;
}

function ReportsView({
  group,
  license,
  track,
  users = [],
  progress = [],
  courseWorks = {},
  groupLicense = {},
}) {
  const { sent_to_google } = groupLicense;

  useEffect(() => {
    console.log("MOUNT", group);
    console.log("MOUNT", license);
    console.log("MOUNT", users);
    console.log("MOUNT", courseWorks);
    console.log("MOUNT", courseWorks);
    console.log("MOUNT", groupLicense);
  }, []);

  return (
    <div className="f-view">
      <div className="f-row-vw draggableX flex f-d-row marginless">
        {/* Left Column: User list */}
        <div className="f-col-s12 flex f-d-column padless">
          <div
            className="card inactive expand cell sticky-top"
            style={{ zIndex: 10 }}
          >
            Click user for report
          </div>

          {users.map((user) => (
            <a
              key={user.id}
              href={userReportPath({ group, license, track, user })}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="card secondary expand bordered bordered-hoverable cell sticky-left"
                style={{ zIndex: 5 }}
              >
                <div className="primary-text">
                  <b>{truncateText(user.username, 20)}</b>
                </div>
                <div className="screen-m-up">
                  {truncateText(`${user.first_name} ${user.last_name}`, 20)}
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Right Columns: Progress data */}
        {progress.length > 0 ? (
          progress.map((p, i) => (
            <div key={i} className="f-col-s12 flex f-d-column padless">
              <div className="card inactive text-center cell sticky-top">
                <div className="t-tip">
                  <span
                    className="t-tip-text tip-bottom drop-shadow"
                    id={`tip_${i}`}
                  >
                    {p.title}
                  </span>
                  {/* Show Google Classroom icon or default icon */}
                  {sent_to_google && courseWorks[p.title] ? (
                    <img
                      src="https://cs2n.s3.amazonaws.com/assets/logos/classrooms-logo-282px.png"
                      width="24px"
                      alt="Google Classroom"
                    />
                  ) : (
                    <i
                      className={`bx ${
                        p.elemental_type === "CmraBlocksElement"
                          ? "bx-laptop icon-medium"
                          : iconForElementalType(p.elemental_type)
                      }`}
                    />
                  )}
                  {p.title.split(":").pop()}
                  <br />
                  {sent_to_google && courseWorks[p.title]
                    ? courseWorks[p.title]
                    : null}
                </div>
              </div>

              {users.map((user) => (
                <a
                  key={`${p.id}-${user.id}`}
                  href={userReportPath({ group, license, track, user })}
                  target="_blank"
                  rel="noreferrer"
                >
                  {renderProgressCard({ p, user, index: i })}
                </a>
              ))}
            </div>
          ))
        ) : (
          // If no progress
          <div className="f-col-s12 flex f-d-column padless">
            <div className="card inactive text-center cell">
              No requirable activities on this page
            </div>
            {Array.from({ length: users.length }).map((_, idx) => (
              <div key={idx} className="card inactive cell text-center">
                {/* Just a placeholder cell */}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

/**
 * Helper function that returns the proper icon class
 * for the `elemental_type` when not "CmraBlocksElement".
 */
function iconForElementalType(elementalType) {
  // In your HAML, you have: p.elemental_type.constantize.icon
  // If that's dynamic, you might map them. For demonstration, we do:
  switch (elementalType) {
    // example:
    // case "SomeOtherElement":
    //   return "bx-some-other-icon"
    default:
      return "bx-book"; // fallback or handle your custom logic
  }
}

/**
 * Helper that truncates text to the given length.
 */
function truncateText(text = "", length = 20) {
  if (text.length <= length) return text;
  return text.slice(0, length) + "...";
}

/**
 * Renders the "progress card" for a single user & assignment.
 * Based on your conditions in the HAML snippet.
 */
function renderProgressCard({ p, user, index }) {
  const completed = p.completed_by?.(user);
  const scorable = p.scorable?.();
  const attempted = p.attempted_by?.(user);
  const score = p.score_for?.(user);

  if (completed && !scorable) {
    // Completed & not scorable
    return (
      <div
        className="card primary cell bordered bordered-hoverable text-center t-hitbox text-center"
        hitbox_id={index}
      >
        <i className="bx bx-check icon-large" />
      </div>
    );
  } else if (completed && scorable) {
    // Completed & scorable
    return (
      <div
        className="card primary cell bordered bordered-hoverable text-center t-hitbox text-center"
        hitbox_id={index}
      >
        Score: {score}%
      </div>
    );
  } else if (!completed && scorable && attempted) {
    // Not completed, scorable, but attempted
    return (
      <div
        className="card secondary cell bordered bordered-hoverable text-center t-hitbox text-center"
        hitbox_id={index}
      >
        Score: {score}%
      </div>
    );
  } else {
    // Not completed, or no score
    return (
      <div
        className="card secondary cell bordered bordered-hoverable t-hitbox text-center"
        hitbox_id={index}
      >
        ---
      </div>
    );
  }
}

ReportsView.propTypes = {
  group: PropTypes.object,
  license: PropTypes.object,
  track: PropTypes.object,
  users: PropTypes.array,
  progress: PropTypes.array,
  courseWorks: PropTypes.object,
  groupLicense: PropTypes.object,
};

export default ReportsView;
